module.exports = __webpack_public_path__ + "static/media/followup.5f843910.svg";